import React from "react";
import { Container, Row } from "react-bootstrap";

import evaluationSchemesService from "presentation/services/evaluation-schemes";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import EvaluationSchemeForm from 'presentation/pages/evaluation-schemes/elements/form';

import {
  mountStageItems
} from 'presentation/pages/evaluation-schemes/functions/stages';

import { preparePostData } from "presentation/pages/evaluation-schemes/functions/schemes";


class EvaluationSchemeAdd extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      evaluationSchemeForm: {},
      actionLoading: false,
      error: false,
      message: '',
      data: [],
      periods: [],
      stages: [],
      stageCriterias: [],
      statusIndications: [],
      totalStageItems: 1,
      totalPeriodItems: 0,
      totalStageCriteriaItems: 0,
      totalStatusIndicationItems: 0,
    };
  }

  componentDidMount() {
    mountStageItems(this);
    this.setState({ loading: false });
  }

  goTo = (destination) => {
    const { history } = this.props;

    history.push(destination);
  };

  handleSubmit = async () => {

    this.setState({ loading: true, actionLoading: true, error: '' });

    const {
      name,
    } = this.state.evaluationSchemeForm;

    if (!name) {
      this.setState({ loading: false, error: true, message: "Por favor, preencha um nome..." });
    } else {
      let scheme = this.state.evaluationSchemeForm;
      let stages = this.state.stages || [];
      let stageCriterias = this.state.stageCriterias || [];
      let periods = this.state.periods || [];
      let statusIndications = this.state.statusIndications || [];
      let postData = preparePostData({ scheme, stages, periods, stageCriterias, statusIndications });

      try {
        const response = await evaluationSchemesService.saveRelated(postData);
        if (response.error == true) {
          this.setState({
            loading: false,
            actionLoading: false,
            error: true,
            message: response.message
          });
        } else {
          this.goTo("/regimes-avaliacao");
        }
      } catch (err) {
        this.setState({
          loading: false,
          actionLoading: false,
          error: true,
          message: err.message
        });
      }
    }
  };

  render() {
    let { location } = this.props;
    let { loading, error, message, actionLoading, evaluationSchemeForm, stages, totalStageItems, periods, totalPeriodItems, stageCriterias, totalStageCriteriaItems, statusIndications, totalStatusIndicationItems } = this.state;
    let { handleSubmit } = this;
    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && (
          <Container>
            <Row>
              <EvaluationSchemeForm
                handleSubmit={handleSubmit}
                loading={loading}
                evaluationSchemeForm={evaluationSchemeForm}
                stages={stages}
                periods={periods}
                stageCriterias={stageCriterias}
                statusIndications={statusIndications}
                totalStageItems={totalStageItems}
                totalPeriodItems={totalPeriodItems}
                totalStageCriteriaItems={totalStageCriteriaItems}
                totalStatusIndicationItems={totalStatusIndicationItems}
                component={this}
              />
            </Row>
          </Container>
        )
        }
      </div>
    );
  };
}

export default EvaluationSchemeAdd;
